<section class="courses-details-area pt-75 pb-50">
  <div class="container">
    <div class="courses-title">
      <h2>Как можно купить курс "{{currentCourse.title}}" ?</h2>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="contact-info-box mb-30">
          <div class="icon">
            <i class='bx bx-envelope'></i>
          </div>
          <h3>Оплатить через Элсом</h3>
          <p><a>11720</a></p>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="contact-info-box mb-30">
          <div class="icon">
            <i class='bx bx-map'></i>
          </div>
          <h3>Оплатить в офисе</h3>
          <p><a href="https://goo.gl/maps/EyZ1wdTjMTpLfamAA" target="_blank">Ул. Байтик Баатыра (Советская) 71а пер.
            Кулатова</a></p>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
        <div class="contact-info-box mb-30">
          <div class="icon">
            <i class='bx bx-phone-call'></i>
          </div>
          <h3>Написать через WhatsApp</h3>
          <p><span><i class='bx bxl-whatsapp'></i></span><a href="{{'https://api.whatsapp.com/send?phone=996702000474&text=' + 'Здравствуйте, Я хочу купить курс: ' + currentCourse.title}}"
            target="_blank">&nbsp; 0770 22 00 44</a></p>
        </div>
      </div>
    </div>
  </div>


  <div class="row">
    <div class="col-lg-8">
      <div class="courses-details-image text-center">
        <!--          <img alt="image" src="{{currentCourse.imgUrl}}">-->
      </div>
    </div>
  </div>
</section>
